import React from 'react';
import CommerceAssociation2023 from 'views/CommerceAssociation2023';


const LifeSkillPage = () => {
  return <CommerceAssociation2023/>;
};

export default LifeSkillPage;